export default __webpack_public_path__ + "static/b9-67865a5ed9dd8cea6868f6971c5c3265.jpg";